import React, {useContext} from "react";
import {ToastContainer} from "react-toastify";
import {ThemeProvider as EmotionThemeProvider} from "emotion-theming";
import {StripeProvider} from "react-stripe-elements";
import styled from "@emotion/styled";
import {ThemeProvider} from "styled-components";
import {UserContext} from "@/contexts/user";
import useSWR from "swr";
import ReactGA from "react-ga4";

ReactGA.initialize("G-043B4RZK2G");

import Routes from "../Routes";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
const expanded = localStorage.getItem("footer") == "false" ? false : true;

let mainColor = "#0f0";
let mainTextColor = "#3c3c3b";

// if (localStorage.getItem("preset") === "Pride") {
//   mainColor =
//     "-webkit-linear-gradient(left, #FBFAF6 0, #FBFAF6 9.09%, #F7AEC4 9.09%, #F7AEC4 18.18%, #74D7EE 18.18%, #74D7EE 27.27%, #603814 27.27%, #603814 36.36%, #010101 36.36%, #010101 45.45%, #DA0A0A 45.45%, #DA0A0A 54.54%, #F09D03 54.54%, #F09D03 63.63%, #E5FE04 63.63%, #E5FE04 72.72%, #08BF02 72.72%, #08BF02 81.81%, #08199B 81.81%, #08199B 90.90%, #77018B 90.90%, #77018B)";
// } else if (localStorage.getItem("preset") === "BlossomBytes") {
//   mainColor = "rgb(253, 195, 171)";
//   mainTextColor = "#883532";
// }

const theme = {
  green: "#0f0",
  mainColor,
  mainTextColor,
  secondaryColor: "",
  secondaryTextColor: "",
  darkGreen: "#0b0",
  veryDarkGreen: "#003b00",
  newGreen: "#62ff86",
  veryLightGrey: "#f6f7f9",
  lightGrey: "#c2cad6",
  grey: "#8595ad",
  darkGrey: "#52627a",
  veryDarkGrey: "#3c3c3b",
  almostBlack: "#212428",
  lightRed: "#FFBDBD",
  red: "#EF4E4E",
  darkRed: "#AB091E",
  monoFont: "'IBM Plex Mono', monospace",
  sansFont: "'IBM Plex Sans', sans-serif",
  shadow: "2px 2px 0px #cdcdcd, -2px -2px 0px #ffffff",
  transition: "all 0.2s ease-in-out",
};

const Layout = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  width: 100%;

  main {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
`;

const headerFetcher = url => fetch(url).then(res => res.json());

export default function App() {
  const {user} = useContext(UserContext);
  const {data: topHeaderData} = useSWR(
    `https://us-central1-hackernoon-app.cloudfunctions.net/app2/header-data?path=/`,
    // `https://us-central1-hackernoon-app.cloudfunctions.net/app2/header-data?path=/`,
    //`http://localhost:8080/header-data${parentCategory ? `?parentCategory=${parentCategory}` : `${path ? `?path=${path}` : ""}`}`,
    headerFetcher,
  );
  let headerData = topHeaderData && topHeaderData?.status === "ok" ? topHeaderData.headerData : {};

  return (
    <div className="App">
      <EmotionThemeProvider theme={theme}>
        <ThemeProvider theme={theme}>
          <StripeProvider apiKey="pk_live_8DmLDMDOXoT4jt9QG4OS3emh">
            <Layout>
              <Header />
              <main>
                <ToastContainer position="top-center" autoClose={2000} />
                <Routes />
              </main>
              <Footer footerData={headerData.footerItems} expanded={expanded} />
            </Layout>
          </StripeProvider>
        </ThemeProvider>
      </EmotionThemeProvider>
    </div>
  );
}
